import { useMemo } from 'react'
import { useChainId } from 'wagmi'

import { useCopy } from 'hooks/helpers'

import { useAirdropList } from 'state/airdrop/hooks'
import { usePrivateKey, useSelfGeneratedAddress } from 'state/user/hooks'

import { download } from 'utils/helpers'
import { Button, Icon } from 'components/ui'
import { shortenText } from 'utils/stringUtils'
import { getEtherscanLink } from 'utils/crypto'

import { SelfWrap, SelfText, SelfItemWrap, SelfItem, SelfItemText, ButtonCopyItem, StyledLink } from './Style'

export function SelfGeneratedInfo() {
  const privateKey = usePrivateKey()
  const airdropList = useAirdropList()
  const privateKeyAddress = useSelfGeneratedAddress()

  const chainId = useChainId()

  const [isCopied, onClick] = useCopy(privateKey || '')

  const shortenPrivateKeyAddress = useMemo(
    () => (privateKeyAddress ? shortenText(privateKeyAddress, 5, 28) : '-'),
    [privateKeyAddress],
  )

  function generateFileData() {
    const recipients = airdropList.length

    const date = new Date()
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    const currentDate = `${day}/${month}/${year}`

    const author = `_mad-assembly. The ultimate airdrop tool.`

    return `Date: ${currentDate}\nAmount of recipients: ${recipients}\nAddress: ${privateKeyAddress}\nPrivateKey: ${privateKey}\n\n\n${author}`
  }

  const handleDownload = () => {
    const fileData = generateFileData()
    const blob = new Blob([fileData], { type: 'text/plain' })

    download(blob, '_MadAssambly-PK.txt')
  }

  return (
    <SelfWrap>
      <SelfText>Please make a copy of your temporary private key</SelfText>

      <SelfItemWrap>
        <SelfItem>
          <SelfItemText>_address</SelfItemText>
          <StyledLink href={`${getEtherscanLink(chainId, privateKeyAddress ?? '', 'address')}`}>
            {shortenPrivateKeyAddress}
            <Icon name='externalLink' size='extraMedium' />
          </StyledLink>
        </SelfItem>

        <SelfItem>
          <SelfItemText>_private-key</SelfItemText>
          <ButtonCopyItem type='primary' onClick={onClick}>
            ***********************
            {isCopied ? <span>_copied</span> : <Icon name='copy' size='extraMedium' />}
          </ButtonCopyItem>
        </SelfItem>
      </SelfItemWrap>

      <Button onClick={handleDownload}>_download-data</Button>
    </SelfWrap>
  )
}
